import DEFINES from "@/defines";
import Register from "@/pages/Auth/Register";
import Login from "../pages/Auth/Login";

import NotFoundPage from "@/components/NotFoundPage";

import Companies from "../pages/companies/List";
import CompanyRoot from "../pages/companies/company/CompanyRoot.vue";
import CompanyProfile from "../pages/companies/company/CompanyProfile.vue";
import CompanyPaymentConfig from "../pages/companies/company/CompanyPaymentConfig.vue";
import CompanyThemeConfig from "../pages/companies/company/CompanyThemeConfig.vue";
import CompanyTeamConfig from "../pages/companies/company/CompanyTeam.vue";
import CompanySetting from "../pages/companies/company/CompanySetting.vue";
import CompanyWhiteLabel from "../pages/companies/company/CompanyWhiteLabel.vue";
import CompanyHistory from "../pages/companies/company/CompanyHistory.vue";
import CompanyInvoice from "../pages/companies/company/CompanyInvoice.vue";
import FestivalHomePage from "../pages/companies/company/FestivalHomePageGrape.vue";
// import FestivalHomePage from "../pages/companies/company/FestivalHomePageGrape.vue";

import CompanyCookies from "../pages/companies/company/CompanyCookies.vue";
//import CompanyProfile from '../pages/companies/Profile';
import CompanyDashboard from "../pages/companies/Dashboard";
import CompanyCreate from "../pages/companies/Create";
import CompanyPostPaymentRedirection from "../pages/companies/company/CompanyPostPaymentRedirection";

import PageRoot from "../pages/companies/pages/Root";
import PageList from "../pages/companies/pages/List";
import PageSave from "../pages/companies/pages/Save";

import FilmsDashboard from "../pages/films/Overview";
import Film from "../pages/films/Update/FilmUpdateRoot.vue";
import FilmUploader from "../pages/films/Uploader";

import UserProfile from "../pages/user/Profile";

import AdminRoot from "../pages/admin/Root";
import AdminDashboard from "../pages/admin/Dashboard";
import AdminCompaniesList from "../pages/admin/company/List";
import AdminCompanyProfile from "@/pages/admin/company/Profile";
import AdminFilmList from "../pages/admin/Film/List";
import AdminTags from "../pages/admin/tag/List";
import AdminUserList from "../pages/admin/user/List";
import AdminScreeningList from "../pages/admin/screening/List";
import AdminWidgetRoot from "../pages/admin/widget/WidgetRoot"
import AdminWidgetList from "../pages/admin/widget/List";
import AdminWidgetSave from "../pages/admin/widget/Save";
import AdminWidgetCustomize from "../pages/admin/widget/WidgetCustomize"
import AdminPageList from "../pages/admin/pages/List"
import AdminPageSave from "../pages/admin/pages/page/Save";
import AdminPageManegeWidgets from "../pages/admin/pages/page/ManageWidgets"
import AdminPageRoot from "../pages/admin/pages/page/Root"


// Admin Subscription
import AdminSubscriptionList from "../pages/admin/subscription/List";
import AdminSubscriptionDashboard from "../pages/admin/subscription/Dashboard";

//Impersonation
import ImpersonationConfirmation from "../pages/user/impersonation/confirmation.vue";

import ScreenerRoot from "@/pages/screener/Root";
import ScreenerList from "@/pages/screener/List";
import ScreenerSave from "@/pages/screener/Save";

//Consumer
import ConsumerRoot from "@/pages/consumer/Consumer";
import ConsumerProfile from "@/pages/consumer/ConsumerProfile";
import ConsumersRoot from "@/pages/consumers/Consumers";
import ConsumerList from "@/pages/consumers/List";

//Revenue
import RevenueRoot from "@/pages/revenue/Root";
import RevenueList from "@/pages/revenue/List";

//Group Screening Monetization
import MonetizationRoot from "@/pages/monetization/Root";
import GroupTicketList from "@/pages/monetization/GroupTicketList";
import GroupTicketSave from "@/pages/monetization/GroupTicketSave";

// Sales
import PurchaseList from "@/pages/monetization/purchase/List";
import PurchaseDetail from "@/pages/monetization/purchase/Purchase";

//Coupon

import CouponRoot from "@/pages/coupon/Root";
import CouponList from "@/pages/coupon/CouponList";
import CouponSave from "@/pages/coupon/CouponSave";

// UploadLink

import UploadLink from "@/pages/films/UploadLinkLogin";

//Transaction
import TransactionRoot from "@/pages/transaction/Root";
import TransactionList from "@/pages/transaction/List";

// Admin Consumers
import AdminConsumerList from "../pages/admin/consumer/List";

//Analytics
import AnalyticsRoot from "@/pages/analytics/Root";
import AnalyticsList from "@/pages/analytics/List";
//Venue
import VenueRoot from "@/pages/venue/VenueRoot";
import VenueList from "@/pages/venue/VenueList";
import VenueUpdate from "@/pages/venue/VenueUpdate";
//program

import ProgramRoot from "@/pages/program/ProgramRoot";
import ProgramList from "@/pages/program/ProgramList";
import ProgramIdRoot from "@/pages/program/_programId/ProgramIdRoot";
import ProgramUpdate from "@/pages/program/_programId/ProgramUpdate";
import ProgramEvent from "@/pages/program/_programId/ProgramEvent";
import ProgramFilter from "@/pages/program/_programId/ProgramFilter";
// Affiliations
import AffiliationRoot from "@/pages/affiliation/Root";
import AffiliationList from "@/pages/affiliation/List";
import AffiliationSave from "@/pages/affiliation/Save";

//Payouts
import PayoutRoot from "@/pages/payout/Root";
import PayoutList from "@/pages/payout/List";

// Subscription
import SubscriptionIndex from "@/pages/subscription/Index"
import SubscriptionList from "@/pages/subscription/List"
import SubscriptionPlans from "@/pages/subscription/SubscriptionPlans"

// Film Makers
import FilmMakersRoot from "../pages/filmMakers/FilmMakersRoot.vue";
import FilmMakerList from "../pages/filmMakers/FilmMakerList.vue";
import FilmMakerUpdate from "../pages/filmMakers/_filmMakerId/FilmMakerUpdate.vue";

// Translations
import TranslationsRoot from "../pages/translations/TranslationsRoot.vue"
import TranslateTags from "../pages/translations/TranslateTags.vue"

export default [
  {
    path: "/",
    redirect: "/login",
    name: "RootPath",
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: true,
    },
  },

  {
    path: "/login",
    name: "Login",
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: true,
    },
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: true,
    },
    component: Register,
  },
  {
    path: "/companies",
    name: "Companies",
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: Companies,
  },
  {
    path: "/companies/create",
    name: "CreateCompany",
    meta: {
      layout: DEFINES.LAYOUT_APP,
      public: false,
    },
    component: CompanyCreate,
  },
  {
    path: "/company/:company_id/payment/returnUrl",
    name: "CompanyPostPaymentRedirection",
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: true,
    },
    component: CompanyPostPaymentRedirection,
  },
  {
    path: "/company/:company_id",
    component: CompanyRoot,
    children: [
      {
        path: "",
        name: "CompanyRoot",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyProfile,
      },
      {
        path: "profile",
        name: "CompanyProfile",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyProfile,
      },
      {
        path: "payment",
        name: "CompanyPayment",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyPaymentConfig,
      },
      {
        path: "theme",
        name: "CompanyTheme",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyThemeConfig,
      },
      {
        path: "team",
        name: "CompanyTeam",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyTeamConfig,
      },
      {
        path: "setting",
        name: "CompanySetting",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanySetting,
      },
      {
        path: "whitelabel",
        name: "CompanyWhiteLabel",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyWhiteLabel,
      },
      {
        path: "history",
        name: "CompanyHistory",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyHistory,
      },
      {
        path: "invoice",
        name: "CompanyInvoice",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyInvoice,
      },
      {
        path: "homepage",
        name: "CompanyFestivalHomepagge",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: FestivalHomePage,
      },
      {
        path: "cookies",
        name: "CompanyCookies",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CompanyCookies,
      },
    ],
  },
  {
    path: "/company/:company_id/dashboard",
    name: "CompanyDashboard",
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: CompanyDashboard,
  },
  {
    path: "/company/:company_id/films",
    name: "FilmsDashboard",
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: FilmsDashboard,
  },
/* Programs */
{
  path: "/company/:company_id/programs",
  name: "programs",
  component: ProgramRoot,
  meta: {
    layout: DEFINES.LAYOUT_APP,
  },
  children: [
    {
      path: "list",
      name: "programs.list",
      meta: {
        layout: DEFINES.LAYOUT_APP,
      },
      component: ProgramList,
    },
    {
      path: ":program_id",
      name: "programs.root",
      meta: {
        layout: DEFINES.LAYOUT_APP,
      },
      component: ProgramIdRoot,
      children: [
        {
        path: "/",
        name: "programs.update",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ProgramUpdate,
      },
      {
        path: "events",
        name: "programs.events",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ProgramEvent,
      },
      {
        path: "filters",
        name: "programs.filters",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ProgramFilter,
      }

      ],
    },


  ],
},
  /* Pages */
  {
    path: "/company/:company_id/page",
    name: "page",
    component: PageRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "list",
        name: "page.list",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: PageList,
      },
      {
        path: "create",
        name: "page.create",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: PageSave,
      },
      {
        path: "save/:page_id",
        name: "page.save",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: PageSave,
      },
    ],
  },

  /* Transactions */
  {
    path: "/company/:company_id/transaction",
    component: TransactionRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "list",
        name: "transaction.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: TransactionList,
      },
    ],
  },

  {
    path: "/company/:company_id/film/:film_id",
    name: "Film",
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: Film,
  },
  {
    path: "/company/:company_id/film/:film_id/link/:link_id",
    name: "UploadLink",
    component: UploadLink,
    meta: {
      public: true,
      layout: DEFINES.LAYOUT_AUTH,
    },
  },
  {
    path: "/company/:company_id/film/:film_id/uploader",
    name: "FilmUploader",
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: FilmUploader,
  },
  {
    path: "/profile",
    name: "UserProfile",
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: UserProfile,
  },

  /* Subscriptions */
  {
    path: '/company/:company_id/subscription',
    name: 'subscription.index',
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    component: SubscriptionIndex,
    children: [
      {
        path: 'list',
        name: 'subscription.list',
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: SubscriptionList,
      },
      {
        path: 'plans',
        name: 'subscription.plans',
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: SubscriptionPlans,
      }
    ],

  },
  // {
  //   path: '/company/:company_id/not-subscribed',
  //   name: 'NotSubscribed',
  //   meta: {
  //     layout: DEFINES.LAYOUT_APP,
  //   },
  //   component: NotSubscribed,
  // },
  // {
  //   path: '/company/:company_id/subscription/success',
  //   name: 'SubscriptionSuccess',
  //   meta: {
  //     layout: DEFINES.LAYOUT_APP,
  //   },
  //   component: SubscriptionSuccess,
  // },

  /* Screeners */
  {
    path: "/company/:company_id/screener",
    name: "screener",
    component: ScreenerRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "list",
        name: "screener.list",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ScreenerList,
      },
      {
        path: "create",
        name: "screener.create",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        redirect: "list",
      },
      {
        path: "save/:screener_id",
        name: "screener.save",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ScreenerSave,
      },
    ],
  },
  /**
   * VOD
   */
  {
    path: "/company/:company_id/vod",
    name: "vod",
    component: ScreenerRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "list",
        name: "vod.list",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ScreenerList,
      },
      {
        path: "create",
        name: "vod.create",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ScreenerSave,
      },
      {
        path: "save/:screener_id",
        name: "vod.save",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ScreenerSave,
      },
    ],
  },
  /* Consumers */
  {
    path: "/company/:company_id/consumers",
    component: ConsumersRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "consumers.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ConsumerList,
      },
    ],
  },
  /* Revenue */
  {
    path: "/company/:company_id/revenue",
    component: RevenueRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "revenue.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: RevenueList,
      },
    ],
  },
  /* Coupons */
  {
    path: "/company/:company_id/coupon",
    component: CouponRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "company.coupon.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CouponList,
      },
      {
        path: ":coupon_id/save",
        name: "company.coupon.update",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: CouponSave,
      },
    ],
  },
  /* Affiliations */
  {
    path: "/company/:company_id/affiliation",
    component: AffiliationRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "affiliations.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: AffiliationList,
      },
      {
        path: ":affiliation_id/save",
        name: "affiliation.update",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: AffiliationSave,
      },
    ],
  },
  /* Group Screening Monetization */
  {
    path: "/company/:company_id/group-ticket",
    component: MonetizationRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "group.ticket.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: GroupTicketList,
      },
      {
        path: "create",
        name: "group.ticket.create",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: GroupTicketSave,
      },
      {
        path: "save/:pricing_id",
        name: "group.ticket.save",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: GroupTicketSave,
      },
    ],
  },

  /* Company sales - Monetization */
  {
    path: "/company/:company_id/sales",
    component: MonetizationRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "purchase.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: PurchaseList,
      },
      {
        path: ":purchase_id",
        name: "purchase.detail",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: PurchaseDetail,
      },
    ],
  },
  {
    path: "/company/:company_id/consumer/:consumer_id",
    component: ConsumerRoot,
    children: [
      {
        path: "",
        name: "consumer.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ConsumerProfile,
      },
    ],
  },

  // Admin
  {
    path: "/admin",
    redirect: "admin/dashboard",
    component: AdminRoot,
    children: [
      {
        path: "dashboard",
        name: "AdminDashboard",
        component: AdminDashboard,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      // Companies
      {
        path: "companies",
        name: "AdminCompaniesList",
        component: AdminCompaniesList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      {
        path: "company/:company_id/profile",
        name: "AdminCompanyProfile",
        component: AdminCompanyProfile,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      // Screening
      {
        path: "screening/list",
        name: "AdminScreeningList",
        component: AdminScreeningList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      // Consumers
      {
        path: "consumers/list",
        name: "AdminConsumerList",
        component: AdminConsumerList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      // Consumers
      {
        path: "film/list",
        name: "AdminFilmList",
        component: AdminFilmList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      {
        path: "users/list",
        name: "AdminUserList",
        component: AdminUserList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      {
        path: "widget/list",
        name: "AdminWidgetList",
        component: AdminWidgetList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      {
        path: "widget/:widget_id",
        component: AdminWidgetRoot,
        children: [
          {
            path: "",
            name: "AdminWidgetRoot",
            meta: {
              layout: DEFINES.LAYOUT_ADMIN,
            },
            component: AdminWidgetSave
          },
          {
            path: "customize",
            name: "AdminWidgetCustomize",
            meta: {
              layout: DEFINES.LAYOUT_ADMIN,
            },
            component: AdminWidgetCustomize
          }
        ]
      },
      {
        path: "page/list",
        name: "AdminPageList",
        component: AdminPageList,
        meta: {
          layout: DEFINES.LAYOUT_ADMIN,
        },
      },
      {
        path: "page/:page_id",
        component: AdminPageRoot,
        children: [
          {
              path: "",
              name: "AdminPageRoot",
              component: AdminPageSave,
              meta: {
                layout: DEFINES.LAYOUT_ADMIN,
              },
          },
          {
            path: "customize",
            name: "AdminPageManageWidgets",
            component: AdminPageManegeWidgets,
            meta: {
              layout: DEFINES.LAYOUT_ADMIN,
            },
          }
        ]

      }
    ],
  },

  // Impersonation
  {
    path: "/user/:user_id/impersonation/confirm",
    name: "ImpersonationConfirmation",
    component: ImpersonationConfirmation,
    meta: {
      layout: DEFINES.LAYOUT_ADMIN,
    },
  },

  /* venues */
  {
    path: "/company/:company_id/venue",
    name: "venue",
    component: VenueRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "list",
        name: "venue.list",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: VenueList,
      },
      {
        path: "update/:venue_id",
        name: "venue.update",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: VenueUpdate,
      },
    ],
  },

  // Fallback route
  {
    path: "*",
    name: "notfound",
    component: NotFoundPage,
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
    },
  },
  // Avails Manager
  // {
  //   path: '/company/:company_id/avail_links',
  //   name: 'AvailLinksList',
  //   meta: {
  //     layout: DEFINES.LAYOUT_APP,
  //   },
  //   component: AvailLinksList,
  // },
  {
    path: "/company/:company_id/analytics",
    component: AnalyticsRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "analytics.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: AnalyticsList,
        props: true,
      },
    ],
  },
  {
    path: "/company/:company_id/payout",
    component: PayoutRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "",
        name: "payout.index",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: PayoutList,
        props: true,
      },
    ],
  },

  // Film Makers
  {
    path: "/company/:company_id/film-makers",
    component: FilmMakersRoot,
    name: "film.makers.index",
    children: [
      {
        path: "",
        name: "film.makers.list",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: FilmMakerList,
      },
      {
        path: ":filmMakerId/profile",
        name: "film.maker.profile",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: FilmMakerUpdate,
      }
    ]
  },
  /* Programs */
  {
    path: "/company/:company_id/program",
    component: ProgramRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "list",
        name: "program.list",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: ProgramList,
      },
    ],
  },
  /* Translations */
  {
    path: "/company/:company_id/translations",
    component: TranslationsRoot,
    meta: {
      layout: DEFINES.LAYOUT_APP,
    },
    children: [
      {
        path: "tags",
        name: "translation.tags",
        meta: {
          layout: DEFINES.LAYOUT_APP,
        },
        component: TranslateTags,
      },
    ],
  },
];
